export default __webpack_public_path__ + "static/media/trade-manual.72afa4a3.mp4";